// extracted by mini-css-extract-plugin
var _1 = "ra-menu-item-box";
var _2 = "ra-menu-item-box-details";
var _3 = "ra-menu-item-box-img";
var _4 = "ra-menu-item-box-text";
var _5 = "ra-menu-item-box-title";
export { _1 as "menuItemBoxCls", _2 as "menuItemBoxDetailsCls", _3 as "menuItemBoxImgCls", _4 as "menuItemBoxTextCls", _5 as "menuItemBoxTitleCls" }
